import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { z } from 'zod'
import { authenticatedRoute } from '../_authenticated'
import { publicWithTabsRoute } from '../_publicWithTabs'
import { Box } from '@chakra-ui/react'
import { ListCardGridSkeleton } from '@/components/skeletons'

const ListsOverview = lazy(() => import('@/pages/lists/ListsOverview'))
const ListDetails = lazy(() => import('@/pages/lists/ListDetails'))
const CollaborativeListDetails = lazy(() => import('@/pages/lists/CollaborativeListDetails'))

function ListsOverviewWrapper() {
  return (
    <Suspense>
      <ListsOverview />
    </Suspense>
  )
}

function ListDetailsWrapper() {
  return (
    <Suspense>
      <ListDetails />
    </Suspense>
  )
}

function CollaborativeListDetailsWrapper() {
  return (
    <Suspense>
      <CollaborativeListDetails />
    </Suspense>
  )
}

// Search params schema for lists route
const listsSearchSchema = z.object({
  // #30: 'featured' is a real tab (see `ListsFilterTabBar`'s `tabs`) but was
  // missing from this enum — any `?tab=featured` deep link (share link,
  // notification, onboarding tour) failed validation, `.catch(undefined)`
  // silently discarded it, and ListsOverview fell back to 'personal'.
  tab: z.enum(['personal', 'group', 'community', 'following', 'featured', 'search']).optional().catch(undefined),
  q: z.string().optional().catch(undefined),
})

// Authenticated lists index route (with tab bar)
export const listsIndexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/lists',
  component: ListsOverviewWrapper,
  validateSearch: listsSearchSchema,
})

// Search params schema for list details route
const listDetailsSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
})

// List details route - accessible both authenticated and unauthenticated (for sharing)
// Uses publicWithTabsRoute so it has the tab bar
export const listDetailsRoute = createRoute({
  getParentRoute: () => publicWithTabsRoute,
  path: '/lists/$urlKey',
  component: ListDetailsWrapper,
  validateSearch: listDetailsSearchSchema,
})

// Collaborative list details route - requires authentication
export const collaborativeListDetailsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/lists/collaborative/$urlKey',
  component: CollaborativeListDetailsWrapper,
})
